import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Body2 } from 'ui/theme';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useUpdateIngestionPolicies } from '../hooks';

export const TEXT = {
  ID: 'save-event-modal',
  DESCRIPTION:
    'Saved events are visible throughout the application and new instances of this event will be stored.',
  CONFIRM_BUTTON: 'Save event',
};

export const headerText = (eventName: string) => `Save ${eventName}?`;

type Props = {
  eventName: string;
  onClose: () => void;
};

export const SaveEventModal = ({ onClose, eventName }: Props) => {
  const { save } = useUpdateIngestionPolicies();

  const saveEvent = async () => {
    await save(eventName);
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>{headerText(eventName)}</ModalHeader>
      <ModalBody>
        <Body2>{TEXT.DESCRIPTION}</Body2>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton onClick={saveEvent} size={BUTTON_SIZES.LARGE}>
          {TEXT.CONFIRM_BUTTON}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
